<template>
  <div>
    <div v-if="displayType === 'long'">
      <p>Market Capitalization categories are defined as follows:</p>
      <p>
        Micro Cap: Under $250M,
        Small Cap: $250M - $2B,
        Mid Cap: $2B - $10B,
        Large Cap: $10B - $200B,
        Mega Cap: Over $200B.
      </p>

      <p>
        This Market Cap Breakdown chart applies to directly held securities as well as equities held through funds.
        <template v-if="portfolio && benchmark">
          This breakdown applies to {{ percentCoverage.portfolio }} of {{ portfolio.name }} and {{ percentCoverage.benchmark }} of {{ benchmark.name }}.
        </template>
        <template v-else-if="portfolio">
          This breakdown applies to {{ percentCoverage.portfolio }} of {{ portfolio.name }}.
        </template>
        <template v-else-if="benchmark">
          This breakdown applies to {{ percentCoverage.benchmark }} of {{ benchmark.name }}.
        </template>
      </p>

      <p>Market Capitalization data from funds uses holdings as of data of most recent NPORT SEC filing.</p>
    </div>

    <div v-else>
      <p>Market Capitalization categories are defined as follows:</p>
      <p>
        Micro Cap: Under $250M,
        Small Cap: $250M - $2B,
        Mid Cap: $2B - $10B,
        Large Cap: $10B - $200B,
        Mega Cap: Over $200B.
      </p>

      <p>
        This Market Cap Breakdown chart applies to directly held securities as well as equities held through funds.
        <template v-if="portfolio && benchmark">
          This breakdown applies to {{ percentCoverage.portfolio }} of {{ portfolio.name }} and {{ percentCoverage.benchmark }} of {{ benchmark.name }}.
        </template>
        <template v-else-if="portfolio">
          This breakdown applies to {{ percentCoverage.portfolio }} of {{ portfolio.name }}.
        </template>
        <template v-else-if="benchmark">
          This breakdown applies to {{ percentCoverage.benchmark }} of {{ benchmark.name }}.
        </template>
      </p>
    </div>
  </div>
</template>


<script>
export default {
  name: 'MarketCapMethodology',
  props: ['displayType', 'portfolio', 'benchmark'],
  computed: {
    breakdown() {
      return {
        portfolio: this.portfolio?.sector_market_cap_asset_class_breakdown,
        benchmark: this.benchmark?.sector_market_cap_asset_class_breakdown,
      };
    },
    coverage() {
      return {
        portfolio: this.breakdown.portfolio?.sector_breakdown_coverage || 0,
        benchmark: this.breakdown.benchmark?.sector_breakdown_coverage || 0,
      };
    },
    percentCoverage() {
      return {
        portfolio: this.formatNumber(this.coverage.portfolio),
        benchmark: this.formatNumber(this.coverage.benchmark),
      };
    },
  },
  methods: {
    formatNumber(number) {
      return number.toLocaleString('en-US', { style: 'percent' });
    },
  },
};
</script>
